import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { usePaginateQuery } from "@/hooks";
import { api } from "@/lib/api";
import { type Paginate, type SearchRequest } from "@/types";

import { type Reward } from "@/modules/recognition/user/types";

export type RewardList = Paginate<Reward>;

export const rewards = createQueryKeys("recognition-rewards", {
  all: (page?: number, filter?: SearchRequest) => [{ page, filter }],
  one: (id?: number) => [id],
});

const include = "children";

export const fetchRewardsQueryOptions = (
  page: number = 0,
  search?: SearchRequest,
) =>
  queryOptions({
    ...rewards.all(page, search),
    queryFn: () =>
      api
        .get<RewardList>(`/recognition/rewards?include=${include}`, {
          params: { page },
        })
        .then((response) => response.data),
  });

export const useFetchRewards = (search?: SearchRequest) =>
  usePaginateQuery((page) => fetchRewardsQueryOptions(page, search));

export const fetchRewardQueryOptions = (id?: number) =>
  queryOptions({
    ...rewards.one(id),
    queryFn: () =>
      api
        .get<Reward>(`/recognition/rewards/${id}`, {
          params: { include },
        })
        .then((response) => response.data),
    enabled: id !== undefined,
  });

export const useFetchReward = (id?: number) =>
  useQuery(fetchRewardQueryOptions(id));
